var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mb-10 pb-10"},[_c('v-card',[_c('v-toolbar',{staticClass:"pa-auto grey lighten-4",attrs:{"flat":"","dense":""}},[_c('v-toolbar-title',[_vm._v("Пользовательское соглашение")])],1),_c('v-card-text',{staticClass:"article"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.article.contents)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }